import React from 'react'
import './Home.css'
import { Helmet } from 'react-helmet';
import {
  Anggota,
  Banner,
  Divider,
  Foto,
  Good,
  Grow,
  Header,
  Hero,
  Kegiatan,
  Location,
  Organisasi,
  Program,
  Runner,
  Visi,
} from "../../components/joinComponents";

const Home = () => {

  const banners ={
    description: "untuk digitalisasi yang lebih baik, dan inovatif"
  };


  return (
    <>
      <Helmet>
        <title>Mundu: Kampung digital dan teknologi berbasis website</title>
        <meta
          name='keyword'
          content='mundu, mundu 1902, moendoe, moendoe 1902, kampung digital, website desa, web keren, lubang buaya, jakarta timur, kampung keren'
        />
        <meta
          name='description'
          content='Mundu adalah sebuah nama daerah yang teletak di Jakarta Timur, Saat ini kami mengedepankan perubahan berbasis teknologi, untuk menjadikan kampung yang terdepan dalam setiap aspek kegiatan.'
        />
        <meta
          name='og:title'
          content='Mundu: Kampung digital dan teknologi berbasis website'
        />
        <meta
          name='og:description'
          content='Mundu adalah sebuah nama daerah yang teletak di Jakarta Timur, Saat ini kami mengedepankan perubahan berbasis teknologi, untuk menjadikan kampung yang terdepan dalam setiap aspek kegiatan.'
        />
      </Helmet>
      <Hero />
      <Grow />
      <Visi />
      <Program />
      {/* <Organisasi /> */}
      <Kegiatan />
      <div className='box-col-home-card'>
        <Anggota />
      </div>
      <Banner data={banners}/>
      <Divider />
      <Location />
      <Good />
      {/* <Footer /> */}
    </>
  );
}

export default Home
